import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import Tabbar from "@/components/Layout/Tabbar.vue";
import NavInfo from "@/components/NavInfo";
interface NavItem {
  name: string;
  path: string;
  title: string;
}

Vue.use(VueRouter);
const routes: Array<RouteConfig> = [
  {
    path: "/",
    component: Tabbar,
    children: [
      ...NavInfo.map((item: NavItem) => ({
        path: item.path,
        component: () => import(/* webpackChunkName: "[request]" */ `@/views/index/${item.name}.vue`),
        name: item.name,
        meta: {
          title: item.title
        }
      }))
    ]
  },
  {
    path: "/chat",
    name: "Chat",
    meta: {
      title: "电子圈"
    },
    component: () => import(/* webpackChunkName: "chat" */ "../views/chat/Home.vue")
  },
  {
    path: "/login",
    name: "Login",
    meta: {
      title: "登录"
    },
    component: () => import(/* webpackChunkName: "login" */ "../views/Login.vue")
  }
];

const router = new VueRouter({
  mode: "history",
  base: "/mobile/",
  routes
});

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title += `-${to.meta.title}`;
  }
  next();
});

export default router;
